import { request } from 'api/request';
import { ACTION_TYPE } from 'api/types';

export type AIBuilderModel = 'gpt-5' | 'gpt-5-mini' | 'gpt-5-nano';

export type AIBuilderProps = {
  input: string;
  journeyShortId: string;
  chatId: string;
  model?: AIBuilderModel;
  files?: File[];
  selectedAction?: {
    id: string;
    type: ACTION_TYPE;
  };
};

export type AIBuilderInterruptProps = {
  journeyShortId: string;
  chatId: string;
};

export type ChatMessage = {
  id: string;
  role: 'user' | 'assistant' | 'tool';
  text?: string;
  toolName?: string;
  toolCallId?: string;
  toolLabel?: string;
  toolDescription?: string;
  status?: string;
  errorType?: string;
  errorMessage?: string;
};

export type MessagesResponse = {
  chatId: string;
  messages: ChatMessage[];
};

export const runAIBuilder = async (data: AIBuilderProps) => {
  const { input, journeyShortId, chatId, model, files = [], selectedAction } = data;
  const formData = new FormData();

  formData.append('input', input);
  formData.append('journeyShortId', journeyShortId);
  formData.append('chatId', chatId);

  if (model) {
    formData.append('model', model);
  }

  if (selectedAction) {
    formData.append('selectedAction', JSON.stringify(selectedAction));
  }

  files.forEach((file) => {
    formData.append('files', file);
  });

  const response = await request.post('v1/ai-builder/run/', formData);
  return response.data;
};

export const loadAIBuilderMessages = async (journeyShortId: string, chatId: string) => {
  const response = await request.get<MessagesResponse>(
    `v1/ai-builder/chat-messages/${journeyShortId}/${chatId}/`
  );
  return response.data;
};

export const deleteAIBuilderHistory = async (journeyShortId: string, chatId: string) => {
  const response = await request.delete(`v1/ai-builder/chat-messages/${journeyShortId}/${chatId}/`);
  return response.data;
};

export const interruptAIBuilder = async (data: AIBuilderInterruptProps) => {
  const response = await request.post('v1/ai-builder/interrupt/', data);
  return response.data;
};
